import {Component, AfterViewInit, ViewChild } from '@angular/core';
import {MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteTrigger as MatAutocompleteTrigger} from '@angular/material/legacy-autocomplete';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {MatLegacyCheckbox as MatCheckbox} from '@angular/material/legacy-checkbox';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MatLegacyInput as MatInput} from '@angular/material/legacy-input';
import {MatSort} from '@angular/material/sort';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {HttpClient} from '@angular/common/http';
import {IdexService} from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';
import {SelectionModel} from '@angular/cdk/collections';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmDialogComponent} from '../../e-signature/confirm-dialog/confirm-dialog.component';
import {AddUserCompanyComponent} from '../add-user-company/add-user-company.component';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {PaginatorComponent} from '../../shared/paginator/paginator.component';
import {AdminApi, Site} from '../admin-api';
import { AddToSiteComponent } from '../add-to-site/add-to-site.component';
import { AddToGroupComponent } from '../add-to-group/add-to-group.component';
import { UpdateQuotaComponent } from '../update-quota/update-quota.component';
import {MatLegacySlideToggleChange as MatSlideToggleChange} from '@angular/material/legacy-slide-toggle';

declare let $: any;

export interface Group {
   group: string;
   siteCode: string;
   expanded: true;
}

export interface Member extends UserData {
   no: number;
   siteCode: string;
   siteName: string;
}

@Component({
   selector: 'app-user-company',
   templateUrl: './user-company.component.html',
   styleUrls: ['./user-company.component.css']
})
export class UserCompanyComponent implements AfterViewInit {
   isLoadingResults = true;
   isRateLimitReached = false;
   resultsLength = 0;
   errorMessage: string;
   contactType: string;
   selectTabIndex = 0;
   user_role: any;
   selectedRowIndex = -1;
   clickActive: boolean;
   roles = [
      {value: 'Admin', viewValue: 'Admin'},
      {value: 'Editor', viewValue: 'Editor'},
      {value: 'Moderator', viewValue: 'Moderator'},
      {value: 'Member', viewValue: 'Member'}
   ];
   displayedColumns = ['select','no', 'name', 'quota', 'menu'];
   dataSource: MatTableDataSource<UserData | Group>;
   selection = new SelectionModel<any>(true, []);
   users: UserData[] = [];
   error_email = false;
   show = true;
   numcheck = 0;
   filterContactValue = '';
   pageSize = 5;
   listSite: Site[] = [];
   allGroup: Group[] = [];
   allMember: Member[] = [];
   listmember: Member[] = [];
   tin: any;
   user: any;
   selectionShare = new SelectionModel<UserData>(true, []);
   groups: UserData[];
   searching: any;
   searchFocused: boolean;
   preventBlur: boolean;
   searchResult: any[];
   searchSize = 8;
   searchvalue: any;
   hiddenMenu: boolean = true;
   private timer: any;
   sortEvent = {'active':'name', 'direction':'asc'};

   role: string;
   isAdmin: boolean;

   @ViewChild('checkInput') public checkbox: MatCheckbox;
   @ViewChild('txtContactId') public txtContId: MatInput;
   @ViewChild('fullName') public txtFullName;
   @ViewChild('groupName') public txtGroupName;
   @ViewChild('email') public txtEmail: MatInput;
   @ViewChild('btnDelContact', {static: true}) public buttonDel: MatButton;
   @ViewChild('btnQuota', {static: true}) public buttonQuota: MatButton;
   @ViewChild('btnGroup', {static: true}) public buttonGroup: MatButton;
   @ViewChild('btnSite', {static: true}) public buttonSite: MatButton;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;

   @ViewChild(MatAutocompleteTrigger)
   private trigger: MatAutocompleteTrigger;

   private addmemberDialog: MatDialogRef<AddUserCompanyComponent>;
   private addtositeDialog: MatDialogRef<AddToSiteComponent>;
   private addtogroupDialog: MatDialogRef<AddToGroupComponent>;
   private updateQuotaDialog: MatDialogRef<UpdateQuotaComponent>;

   constructor(public service: IdexService,
               public adminService: AdminApi,
               public toast: Toast,
               public dialog: MatDialog,
               private translate: TranslateService,
               private http: HttpClient) {
      this.user = this.service.user;
      this.tin = window.localStorage.getItem('tin');
      this.adminService.getRole(this.user.username,this.tin)
         .subscribe((data: any) => {
            if(data){
               this.role = data.role;
               this.isAdmin = this.role === 'Admin';
            }
      });
   }

   ngAfterViewInit() {
      setTimeout(() => {
         this.clickActive = false;
         this.contactType = 'C';
         this.buttonDel.disabled = true;
         this.buttonQuota.disabled = true;
         this.buttonGroup.disabled = true;
         this.buttonSite.disabled = true;
         this.tin = window.localStorage.getItem('tin');
         for (const b of this.user.business) {
            if (b.tin === this.tin) {
               this.user_role = b.role;
            }
         }
         this.getContactList();
      }, 0);

   }

   cultivoChange(item: any) {
      const u = item.type === 'USER' ? 'true' : 'false';
      this.service.put('/work/' + item.siteCode + '/team/' + item.id + '/' + item.role + '?u=' + u + '&device=Web', {})
         .subscribe(() => {
            this.protectLast(this.listmember);
         });
   }

   protectLast(item: any) {
      let j = 0;
      for (let i = 0; i < item.length; i++) {
         if (item[i].role === 'Admin') {
            j++;
         }
      }
      if (j === 1) {
         this.show = false;
      } else {
         this.show = true;
      }
   }

   LoadGroupTabs(event) {
      const indexSelected = event.index;
      if (indexSelected === 0) {
         this.contactType = 'C';
      } else if (indexSelected === 1) {
         this.contactType = 'G';
      }

      this.selection.clear();
      this.selectionShare.clear();
      this.buttonDel.disabled = true;
   }

   getContactList() {
      this.loader.show();
      this.service.get('/work/' + this.tin + '/company/member/list?filter=' + this.filterContactValue)
         .subscribe(data => {
            this.bindDataTable(data);
            this.sortData(this.sortEvent);
            this.loader.hide();
         });
   }

   separateData(members: UserData[]) {
      this.allGroup = [];
      this.allMember = [];
      const tmpMember = [];
      let index = 0;
      for (const member of members) {
         if(member.quota === -1){
            member.quota = 'Unlimit';
         }
         const dataMember = {
            no: index + 1,
            ...member
         };
         tmpMember.push(dataMember);
         index++;
      }
      this.allMember = tmpMember;
   }

   bindDataTable(data: any) {
      this.listSite = data;
      this.separateData(data);
      const dataSiteMember = this.addRowInGroup(this.allGroup, this.allMember);
      this.isLoadingResults = false;
      this.isRateLimitReached = false;
      this.selectedRowIndex = -1;
      this.selection.clear();
      this.buttonDel.disabled = true;
      this.buttonQuota.disabled = true;
      this.buttonGroup.disabled = true;
      this.buttonSite.disabled = true;
      this.resultsLength = this.allMember.length;
      this.dataSource = new MatTableDataSource(this.allMember);
   }

   addRowInGroup(allGroup: any[], allData: Member[]) {
      const page_size = this.paginator.size;
      const page_number = this.paginator.page;
      let dataSiteMember: any[] = [];
      this.listmember = allData.slice(page_number * page_size, page_number * page_size + page_size);
      for (const group of allGroup) {
         const rowsInGroup = this.listmember.filter(item => item.siteCode === group.siteCode);
         if (group.expanded) {
            dataSiteMember = dataSiteMember.concat(group);
            if (rowsInGroup.length > 0) {
               dataSiteMember = dataSiteMember.concat(rowsInGroup);
            }
         } else {
            dataSiteMember = dataSiteMember.concat(group);
         }
      }
      return dataSiteMember;
   }

   isGroup(index, item): boolean {
      return item.hasOwnProperty('group');
   }

   groupHeaderClick(row) {
      if (row.expanded === null) {
         return;
      }
      this.selection.clear();
      this.dataSource = new MatTableDataSource<UserData | Group>([]);
      row.expanded = !row.expanded;
      const data = this.addRowInGroup(this.allGroup, this.allMember);
      this.dataSource = new MatTableDataSource(data);
   }

   hiddenRow(row) {
      const group = this.allGroup.find(item => item.siteCode === row.siteCode);
      return !group.expanded;
   }

   onSearch(filterValue: string) {
      this.searchFocused = false;
      this.searchvalue = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[%|^{}[\]\\]/g.test(value)) {
         this.translate.get('alert.create_folder_errors').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.filterContactValue = filterValue;
         this.getContactList();
      }
   }

   onSearchChange(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         if (this.timer == null) {
            this.service.get('/work/' + this.tin + '/company/member/list?filter=' + kw)
               .subscribe(data => {
                  this.separateData(data);
                  if (this.allMember && this.allMember.length > 0){
                     this.searchResult = this.allMember.slice(0,this.searchSize);
                  } else {
                     this.searchResult = [];
                  }
               });
         }
      }, 300);
   }

   selectSearchItem(item) {
      setTimeout(() => {
         this.searchFocused = false;
      }, 100);
      this.searching = item.id.trim();
      this.filterContactValue = this.searching.toLowerCase();
      this.getContactList();
   }

   onPageChange() {
      this.selection.clear();
      this.dataSource = new MatTableDataSource<UserData | Group>([]);
      const data = this.addRowInGroup(this.allGroup, this.allMember);
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
   }

   activeContact(id: any, email: any, active: any) {
      this.clickActive = true;
      const contactId = id.innerHTML;
      const contactEmail = email.innerHTML;
      const activeFlg = active.checked;
      if (activeFlg === false) {
         this.service.activeContact(contactId, contactEmail)
            .subscribe((response) => {
               this.toast.success(response);
            });
      } else {
         this.service.inactiveContact(contactId, contactEmail)
            .subscribe((response) => {
               this.toast.warn(response);
            });
      }
   }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
      const numSelected = this.selection.selected.length;
      this.buttonDel.disabled = numSelected <= 0;
      this.buttonQuota.disabled = numSelected <= 0;
      this.buttonGroup.disabled = numSelected <= 0;
      this.buttonSite.disabled = numSelected <= 0;
      this.hiddenMenu = numSelected === 0;
      return numSelected === this.listmember.length;
   }

   /** Selects all rows if they are not all selected; otherwise clear selection. */
   masterToggle() {
      if (this.isAllSelected()) {
         this.selection.clear();
         this.buttonDel.disabled = true;
         this.buttonQuota.disabled = true;
         this.buttonGroup.disabled = true;
         this.buttonSite.disabled = true;
      } else {
         this.dataSource.data.forEach(row => {
            this.selection.select(row);
         });
         this.buttonDel.disabled = false;
         this.buttonQuota.disabled = false;
         this.buttonGroup.disabled = false;
         this.buttonSite.disabled = false;
      }
   }


   disableButton(row: any) {
      if (this.contactType === 'C') {
         const numSelected = this.selection.selected.length;
         if (numSelected > 0) {
            this.buttonDel.disabled = false;
            this.buttonQuota.disabled = false;
            this.buttonGroup.disabled = false;
            this.buttonSite.disabled = false;
         } else {
            this.buttonDel.disabled = true;
            this.buttonQuota.disabled = true;
            this.buttonGroup.disabled = true;
            this.buttonSite.disabled = true;
         }
         return this.selection.isSelected(row);
      } else {
         return false;
      }
   }

   openContractDialog(isEdit: boolean,item?: any) {
         const data = {
            isEdit: isEdit,
            username: undefined
         };
         if(item) {
            data.username = item.id
         }
         this.addmemberDialog = this.dialog.open(AddUserCompanyComponent, {
            disableClose: true,
            width: '800px',
            data: data
         });
         this.addmemberDialog.componentInstance.datalist = this.listmember;
         this.addmemberDialog.componentInstance.tin = this.tin;
         this.addmemberDialog.afterClosed().subscribe(result => {
            if (result) {
               this.getContactList();
            }
         });
         this.selectTabIndex = 0;
   }

   openAddToSiteDialog(item: any) {
      const usernames = [];
      usernames.push(item.id);
      this.addtositeDialog = this.dialog.open(AddToSiteComponent, {
         disableClose: true,
         width: '400px',
         data: {usernames: usernames, isMember: true}
      });
      this.addtositeDialog.afterClosed().subscribe(result => {
         
      });
   }

   addToSiteDialog() {
      const usernames = this.selection.selected.map(s => s.id)
      this.addtositeDialog = this.dialog.open(AddToSiteComponent, {
         disableClose: true,
         width: '400px',
         data: {usernames: usernames, isMember: true}
      });
      this.addtositeDialog.afterClosed().subscribe(result => {
         
      });
   }

   openAddToGroupDialog(item: any) {
      const usernames = [];
      usernames.push(item.id);
      this.addtogroupDialog = this.dialog.open(AddToGroupComponent, {
         disableClose: true,
         width: '450px',
         data: {usernames: usernames}
      });
      this.addtogroupDialog.afterClosed().subscribe(result => {
         
      });
   }

   addToGroupDialog() {
      const usernames = this.selection.selected.map(s => s.id)
      this.addtogroupDialog = this.dialog.open(AddToGroupComponent, {
         disableClose: true,
         width: '450px',
         data: {usernames: usernames}
      });
      this.addtogroupDialog.afterClosed().subscribe(result => {
         
      });
   }

   updateUsersQuotaDialog() {
      this.updateQuotaDialog = this.dialog.open(UpdateQuotaComponent, {
         disableClose: true,
         width: '200px;',
         data: {
            users: this.selection.selected
         }
      });
      this.updateQuotaDialog.afterClosed().subscribe(result => {
         this.getContactList();
      });
   }

   updateUserQuotaDialog(item: any) {
      const usernames = [];
      usernames.push(item);
      this.updateQuotaDialog = this.dialog.open(UpdateQuotaComponent, {
         disableClose: true,
         width: '200px;',
         data: {
            users: usernames
         }
      });
      this.updateQuotaDialog.afterClosed().subscribe(result => {
         this.getContactList();
      });
   }

   deleteContacts() {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('main.msg-delete-member').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isMsg = true;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const sitesMembers: any[] = [];
            for (let i = 0; i < this.selection.selected.length; i++) {
               if (this.selection.selected[i].id !== this.user.username) {
                  sitesMembers.push({
                     id: this.selection.selected[i].id,
                     siteCode: this.selection.selected[i].siteCode,
                  });
               }
            }
            this.service.deleteUserSite(sitesMembers)
               .subscribe((response) => {
                  this.translate.get('main.delete-member').subscribe(s => {
                     this.toast.success(s);
                  });
                  this.selection.clear();
                  this.getContactList();
               }, error1 => {
                  this.toast.error(error1);
               });
         }
      });
   }

   deleteContact(item: any) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('main.msg-delete-member').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isMsg = true;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const sitesMembers: any[] = [];
            if (item.id !== this.user.email) {
               sitesMembers.push({
                  id: item.id,
                  siteCode: item.siteCode,
               });
            }
            this.service.deleteUserSite(sitesMembers)
               .subscribe((response) => {
                  this.translate.get('main.delete-member').subscribe(s => {
                     this.toast.success(s);
                  });
                  this.selection.clear();
                  this.getContactList();
               }, error1 => {
                  this.toast.error(error1);
               });
         }
      });
   }

   activeMember(row: any, event: MatSlideToggleChange){
      row.profile.active = event.checked;
      this.service.activeMember(row.username,event.checked).subscribe((response) => {
         if (event.checked) {
            this.translate.get('eform.activated',{formName: row.username}).subscribe(s => {
               this.toast.success(s);
            });
         } else {
            this.translate.get('eform.inactivated',{formName: row.username}).subscribe(s => {
               this.toast.warn(s);
            });
         }
      });
   }

   isHide(): boolean {
      return this.selection.selected.length === 0;
   }

   sortData(e: any) {
      this.sortEvent = e;
      this.allMember.sort((a: any, b: any) => {
         let comparatorResult = 0;
         switch (e.active) {
           case 'no':
            comparatorResult = b.no - a.no;
            break;
           case 'name':
            comparatorResult = a.name.localeCompare(b.name);
            break;
           case 'quota':
            if (a.quota === 'Unlimit' && b.quota === 'Unlimit'){
               comparatorResult = 0;
            } else if (a.quota !== 'Unlimit' && b.quota === 'Unlimit'){
               comparatorResult = -1
            } else if (a.quota === 'Unlimit' && b.quota !== 'Unlimit'){
               comparatorResult = 1
            } else {
               comparatorResult = a.quota - b.quota;
            }
            break;
           case 'isActive':
            if (a.profile === undefined && b.profile === undefined){
               comparatorResult = 0;
            } else if(a.profile === undefined && b.profile !== undefined){
               comparatorResult = -1
            } else if(a.profile !== undefined && b.profile === undefined){
               comparatorResult = 1;
            }
            else{
               comparatorResult = (a.profile.active === b.profile.active)? 0 : a.profile.active? -1 : 1;
            }
         }
         return comparatorResult * (e.direction == 'asc' ? 1 : -1);
      });
      this.dataSource = new MatTableDataSource(this.allMember);
     }
}

export interface UserData {
   name: string;
   id: string;
   role: string;
   isMemberOfGroup: string;
   quota: any;
}
